export class TableMap {
    public configuration: string = 'configuration';
    public machinesConfiguration: string = 'machinesConfiguration';
    public mymillImportConfiguration: string = 'mymillImportConfiguration';
    public samplesConfiguration: string = 'samplesConfiguration';
    public unitsConfiguration: string = 'unitsConfiguration';
    public dataSet: string = 'dataSet';
    public syncedEvents: string = 'syncedEvents';
    public unsyncedEvents: string = 'unsyncedEvents';
    public appSettings: string = 'appSettings';
    public userProfiles: string = 'userProfiles';
    public axCustomers: string = 'axCustomers';
    public axMachineModels: string = 'axMachineModels';

    public configurationUpdates: string = 'configurationUpdates';

    public userWhitelist: string = 'userWhitelist';
    public quickEditConfigurations: string = 'quickViewConfigurations';

    public myMillMachineItems: string = 'myMillMachineItems';
    public myMillUnitItems: string = 'myMillUnitItems';
    public myMillUnitStatus: string = 'myMillUnitStatus';

    /**
     * Depricated
     */
    public unsyncedFilters: string = 'unsyncedFilters';
    /**
     * Depricated
     */
    public syncedFilters: string = 'syncedFilters';
    public unsyncedFiltersNew: string = 'unsyncedFiltersNew';
    public syncedFiltersNew: string = 'syncedFiltersNew';

    // tslint:disable-next-line: no-empty
    constructor() { }
}
